import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import firebase from 'firebase/app'
import Buefy from 'buefy';
import 'buefy/dist/buefy.css'; //←libからdistに変更。
import 'vue-material/dist/vue-material.min.css'
import VueMaterial from 'vue-material'
// import InfiniteLoading from 'vue-infinite-loading'

Vue.config.productionTip = false
Vue.use(Buefy)

Vue.use(VueMaterial)
// Vue.use(InfiniteLoading)
	
firebase.auth().onAuthStateChanged(function (user) {
	if (user) {
		store.commit('user/set_user', user)
		store.dispatch('tags/init')
		store.dispatch('tabs/init')
		store.dispatch('tags/startListener')
		// store.dispatch('tabs/startListener')
		// store.dispatch('tabs/searchTabs')
		store.dispatch('tabs/set_tabs_ref')
		store.dispatch('user/get_meta_data')
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')